module.exports = __webpack_public_path__ + "img/Frame-62.8a9f5e77.svg";